// imports
import { useTranslation } from 'react-i18next'

import { Icon, Link } from '@bosch/react-frok'

// utils

// styles
import IconRelease from '@/assets/icon-release-notes.svg'
import './Documentation.scss'

type VersionEntry = {
    version?: string
    name?: string
}

type VersionData = {
    history: VersionEntry[]
}

type Props = {
    version?: VersionData
    onShowHistoryClick?: () => void
}

const DocumentationFlyout = ({ version, onShowHistoryClick }: Props) => {
    const { t, i18n } = useTranslation()
    const language = i18n.language || 'en'
    const releaseNotesLabel = language === 'en'
        ? t('general:header:releaseNotes')
        : `${t('general:header:releaseNotes')} (EN)`

    let lastversion = `${t('general:header:version')}: MMA v${version?.history?.[0]?.version}`

    if (version?.history?.[0]?.name)
        lastversion += ` (${version.history[0].name})`

    return (
        <div className="flyout-documentation">
            <h5>{t('general:header:information')}</h5>
            <div className="documentation-links">
                <div className="version-wrapper">
                    <p className='version-info'>{lastversion}</p>
                    <div><Icon iconName='arrow-turn-left' className='arrow-icon' /> &#x00A0; <img src={IconRelease} alt={t('general:header:releaseNotes')} /> &#x00A0;
                        <Link
                            className='version-link'
                            label={releaseNotesLabel}
                            target="_blank"
                            onClick={onShowHistoryClick}
                        />
                    </div>
                </div>
                <div>{t('general:header:userManual')}:&nbsp;
                    <Link
                        icon="book-info"
                        label={
                            <>
                                {t('general:header:docupedia')}
                                <Icon iconName="externallink" />
                            </>
                        }
                        target="_blank"
                        href={
                            language === 'de'
                                ? 'https://inside-docupedia.bosch.com/confluence/pages/viewpage.action?pageId=6063034260'
                                : 'https://inside-docupedia.bosch.com/confluence/pages/viewpage.action?pageId=5850640415'
                        }
                    />
                </div>
            </div>
        </div>
    )
}

export default DocumentationFlyout
